module.exports = __webpack_public_path__ + "static/img/0.aa51d6e9.jpg";